import Vue from 'vue'
import { AuthService } from './AuthService'

export const authService = Vue.observable(new AuthService())
